<template>
    <div class="card ">
        <div class="card-header bg-primary">        
            <div class="row">
                <div class="col-lg-3">
                    <i class="fa fa-database fa-5x"></i>
                </div>
                <div class="col-lg-9 text-right">                
                    <h3>{{dameMes(datos.valor)}}</h3>
                    <h2>{{datos.total}}</h2>
                </div> 
            </div>
        </div>
        <div class="card-body bg-primary">
            <p>{{titulo}}</p>                     
        </div>
    </div>


</template>
<script>    
  export default {
    data () {
      return {
        datos: {},
        titulo: ''
      }
    },
    mounted() {
      this.listarTotales();
    },
    methods: {
        async listarTotales() {
            try {
                let resultados = await this.axios.get(`/reporte_inicio`);
                //console.log(resultados);
                if( resultados.data.contenido.data.length < 1 ){
                    this.datos = {
                        valor:'',
                        total: 0
                    }
                }else {
                    this.datos = resultados.data.contenido.data[0];
                }                

                this.titulo = resultados.data.contenido.titulo;
            } catch (error) {
                console.log('catch: ', error);
            }
        },   
        dameMes(numeroMes){
            let mes = '';
            switch (Number(numeroMes)) {
                case 1:
                    mes = 'ENERO';
                    break;
                case 2:
                    mes = 'FEBRERO';
                    break;
                case 3:
                    mes = 'MARZO';
                    break;
                case 4:
                    mes = 'ABRIL';
                    break;
                case 5:
                    mes = 'JUNIO';
                    break;
                case 6:
                    mes = 'JUNIO';
                    break;
                case 7:
                    mes = 'JULIO';
                    break;
                case 8:
                    mes = 'AGOSTO';
                    break;
                case 9:
                    mes = 'SEPTIEMBRE';
                    break;
                case 10:
                    mes = 'OCTUBRE';
                    break;
                case 11:
                    mes = 'NOVIEMBRE';
                    break;
                case 12:
                    mes = 'DICIEMBRE';
                    break;
                default:
                    mes = 'REGISTROS TOTALES';
                    break;
            }
            return mes;
        }
    }

  }
</script>
